import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import "./Modal.css";

const Modal = ({ isOpened, closeHandler, children }) => {
  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        closeHandler();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 
  return (
    <div  className={`modal-wrapper ${isOpened ? "opened" : ""}`}>
      <div ref={ref} className="modal">
        <div className="modal-close-button" onClick={closeHandler}>✖</div>
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.any,
  isOpened: PropTypes.bool,
  closeHandler: PropTypes.func
};

Modal.defaultProps = {
  children: "",
  isOpened: false,
  closeHandler: null
};

export default Modal;
